import React, { Fragment } from "react";
import { NavLink } from "react-router-dom";
import ShowActiveModules from "app/Components/CommanComponents/ShowActiveRoles";
import { ACTIVE_MODULE } from "app/_constants/constant";
const MainBreadcrumb = ({ routeSegments, breadCrumbsText, module }) => {
  return (
    <Fragment>
      <div className="breadcrumb">
        {/* <div className="clientLogo"><img src="/assets/images/cf-logo.png" /></div> */}
        <div className="breadcrumbRightdata">
          <div className="breadcrumb_Title align-items-center">
            {routeSegments ? (
              <Fragment>
                {/* <h1>{routeSegments[routeSegments.length - 1]["name"]}</h1> */}
                <NavLink to={routeSegments[0].path}>
                  <h1>{routeSegments[0]["name"]}</h1>
                </NavLink>
                {/* <h1>{routeSegments[0]["name"]}</h1> */}
              </Fragment>
            ) : null}

            <ul>
              {routeSegments
                ? routeSegments.map((route, index) =>
                    index !== routeSegments.length - 1 ? (
                      index != 0 ? (
                        <li key={index}>
                          <NavLink to={route?.path}>
                            <span className="capitalize">{route?.name}</span>
                          </NavLink>
                        </li>
                      ) : (
                        ""
                      )
                    ) : (
                      <li key={index}>
                        <span className="capitalize text-muted">{route?.name}</span>
                      </li>
                    )
                  )
                : null}
            </ul>
          </div>
          {/* <div className="projectInfo">
            <h2>Aenean commodo ligula eget dolor</h2>
            <p>
              {breadCrumbsText
                ? breadCrumbs()[breadCrumbsText]
                : "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus."}
            </p>
          </div> */}
        </div>
        <ShowActiveModules module={module} />
      </div>
    </Fragment>
  );
};

export default MainBreadcrumb;
